<template>
  <div class="search-container">
    <div class="search" @click.stop.prevent="searchFn">
      <p>{{ descPlaceHolder }}</p>
      <img src="../images/search.png" alt="搜索icon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'search-input',
  components: {},
  props: {
    descPlaceHolder: {
      type: String,
      default: '请搜索相关内容'
    },
    path: {
      type: String,
      default: ''
    }
  },
  methods: {
    searchFn() {
      // 跳转到真实搜索页
      let { path } = this
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss">
.search-container {
  display: flex;
  width: 100%;
  padding: 0 20px;
  .search {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 335px;
    height: 40px;
    border-radius: 20px;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.16) 0%, rgba(244, 254, 255, 0.41) 100%);
    box-shadow: 0px 4px 12px 0px rgba(24, 190, 184, 0.2);
    backdrop-filter: blur(10px);

    box-shadow: 0px 1px 3vw 3px rgba(24, 190, 184, 0.2);
    padding: 0px 16px 0 20px;

    p {
      font-size: 14px;
      font-weight: 500;
      color: #949c9d;
    }

    img {
      width: 14px;
      height: 14px;
    }
  }
}
</style>
